import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../../Axios/base_url";
import { Axios } from "../../Axios";
import toast from "react-hot-toast";
import UseGeneral from "../../hooks/useGeneral";
import { ThreeDots } from "react-loader-spinner";
import CryptoJS from "crypto-js";
import axios from "axios";
import PopUp from "../../components/popup";
const PayCard = ({
  handleConfirm,
  payWithWallet,
  addLoading,
  locations,
  selectedLocations,
  walletValue,
  offlineUserAddress,
  payType,
  handlePay,
}) => {
  const navigate = useNavigate();
  const { language } = UseGeneral();
  const localData = localStorage.getItem("discount_coupon");
  const decryptedBytes = localData && CryptoJS.AES.decrypt(localData, "111");
  const discount2 =
    decryptedBytes && JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  // const [walletValue,setWalletValue]=useState('');
  const [pageLoading, setPageLoading] = useState(false);
  // const handleConfirm = ()=>{
  //   navigate("/success")
  // }
  let localCart = localStorage.getItem("local_cart");
  let cartArr = localCart && JSON.parse(localCart);
  // let totalPrice=
  //

  let cartDataTotalPrice = 0;
  if (cartArr && cartArr.length) {
    for (let k = 0; k < cartArr.length; k++) {
      if (cartArr[k]?.discount * 1 > 0) {
        cartDataTotalPrice +=
          (cartArr[k].price * 1 - cartArr[k].discount * 1) *
          cartArr[k].quantity;
      } else {
        cartDataTotalPrice += cartArr[k].price * 1 * cartArr[k].quantity;
      }
      if (
        cartArr[k].product_optionsarr &&
        cartArr[k].product_optionsarr.length > 0
      ) {
        let options = [...cartArr[k].product_optionsarr];
        for (let y = 0; y < options.length; y++) {
          //
          cartDataTotalPrice += options[y].price * 1 + options[y].quantity * 1;
        }
      }
    }
  }

  const [cartTotalPrice, setCartTotalPrice] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [cartData, setCartsData] = useState([]);
  const [editLocalUserDataModal, setEditLocalUserDataModal] = useState(false);

  const getUserData = () => {
    setPageLoading(true);
    Axios({
      url: BASE_URL + "cart/all_carts_for_user",
      method: "GET",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (Array.isArray(res.result.carts)) {
          setDiscount(res.result.money_minus * 1);
          setCartTotalPrice(res.result.total_price * 1);
          setCartsData(res.result.carts);
        }
      })
      .finally(() => {
        setPageLoading(false);
      })
      .catch((e) => console.log(e));
  };
  const [delivery, setDelivery] = useState(0);
  const getMeData = () => {
    setPageLoading(true);
    Axios({
      url: BASE_URL + "user/me",
      method: "POST",
    })
      .then((res) => {
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        }
        if (res.status == "success") {
          setDelivery(res.result?.location?.region_data?.price);
        }
      })
      .catch((e) => {})
      .finally(() => {
        setPageLoading(false);
      });
  };
  // const getMyWalletValue=()=>{
  //   // const token=local

  //   let greenLocalData=localStorage.getItem('greenTreesUserData')
  //   let greenData=greenLocalData&&JSON.parse(greenLocalData);
  //   //
  //   if(greenData){
  //     axios.get(BASE_URL+user_wallets/get_one_wallet/${greenData?.id})
  //     .then((res)=>{
  //
  //       if(res.data.status=='success'){
  //         setWalletValue(res.data.result.money_value)
  //       }
  //       //
  //     })
  //     .catch(e=>console.log(e))
  //   }
  // }
  useEffect(() => {
    getUserData();
    getMeData();
  }, []);

  return (
    <div className="pay-card-container">
      <div className="d1-flex">
        <p>{language == "ar" ? "اجمالي المنتجات" : "Total Products"}</p>
        <span className="price">
          <strong>{cartDataTotalPrice}</strong>{" "}
          {language == "ar" ? "د.إ" : "AED"}
        </span>
      </div>
      {/* <div className="allPrice my-2">
        <span>{language=='ar'?'الخصم':'Discount'}</span>
        <span>
          <span>{discount2?discount2?.discount:0}</span>
          <span>{language=='ar'?'د.إ':'AWD'}</span>
        </span>
      </div> */}
      <div className="d1-flex">
        <p>{language == "ar" ? "التوصيل" : "Delivery"}</p>
        <span className="price">
          <strong>
            {localStorage.getItem("GreenTreesToken")
              ? selectedLocations?.region_data?.price
              : localStorage.getItem("offlineUserAddress")
              ? JSON.parse(localStorage.getItem("offlineUserAddress"))
                  ?.region_price
              : ""}
          </strong>{" "}
          {language == "ar" ? "د.إ" : "AED"}
        </span>
      </div>
      <div className="d1-flex">
        <p>{language == "ar" ? "الخصم" : "Activate Copoun"}</p>
        <span className="price">
          <strong>
            {discount2?.discount.type == "percentage"
              ? (discount2?.discount.val / 100) * cartDataTotalPrice
              : discount2?.discount.val || 0}
          </strong>{" "}
          {language == "ar" ? "د.إ" : "AED"}
        </span>
        {/* data_send["order_value"] * 1 - (discount?.discount?.type == 'percentage' ? (discount?.discount?.val / 100) *  data_send["order_value"] : discount?.discount?.val ); */}
      </div>
      {walletValue ? (
        <div className="d1-flex">
          <p>
            <span>
              {language == "ar"
                ? "القيمة التي سيتم دفعها من المحفظة"
                : "Value Will Be Paid With Waller"}{" "}
            </span>
          </p>
          <span className="price">
            <strong>{walletValue}</strong> {language == "ar" ? "د.إ" : "AED"}
          </span>
          {/* data_send["order_value"] * 1 - (discount?.discount?.type == 'percentage' ? (discount?.discount?.val / 100) *  data_send["order_value"] : discount?.discount?.val ); */}
        </div>
      ) : null}{" "}
      <div className="dash"></div>
      <div className="d1-flex">
        <strong>{language == "ar" ? "الاجمالي" : "Total"}:</strong>
        <span className="price totalPrice">
          <strong className="totalPriceNum">
            {/* {} */}
            {(localStorage.getItem("GreenTreesToken")
              ? discount2 != null
                ? selectedLocations?.region_data?.price
                  ? cartDataTotalPrice -
                    (discount2?.discount.type == "percentage"
                      ? (discount2?.discount.val / 100) * cartDataTotalPrice
                      : discount2?.discount.val) +
                    selectedLocations?.region_data?.price
                  : cartDataTotalPrice -
                    (discount2?.discount.type == "percentage"
                      ? (discount2?.discount.val / 100) * cartDataTotalPrice
                      : discount2?.discount.val)
                : selectedLocations?.region_data?.price
                ? cartDataTotalPrice - 0 + selectedLocations?.region_data?.price
                : cartDataTotalPrice - 0
              : discount2 != null
              ? +(cartDataTotalPrice || 0) -
                +(discount2?.discount.type == "percentage"
                  ? (discount2?.discount.val / 100) * cartDataTotalPrice
                  : discount2?.discount.val) +
                +offlineUserAddress?.region_price
              : +(cartDataTotalPrice || 0) -
                0 +
                +offlineUserAddress?.region_price) || cartDataTotalPrice}
          </strong>{" "}
          {language == "ar" ? "د.إ" : "AED"}
        </span>
      </div>
      {/* {walletValue && (
        <div className='totalPriceNum'>
          <span>
            {language == "ar"
              ? "المتوفر فى المحفظه:"
              : "Available in the wallet:"}
          </span>
          <span>{walletValue}</span>
        </div>
      )} */}
      {pageLoading ? null : (
        <>
          {" "}
          {addLoading ? (
            <ThreeDots />
          ) : (
            <div className="d-flex gap-2">
              <button className="send-request-button" onClick={handleConfirm}>
                {payType == "wallet_and_cash" ? (
                  <>
                    {language == "ar"
                      ? "دفع عن طريق المحفظة"
                      : "Pay with wallet"}
                  </>
                ) : (
                  <>{language == "ar" ? "ارسال الطلب" : "Send Order"}</>
                )}
              </button>
              {payType == "wallet_and_cash" ? (
                <button className="send-request-button" onClick={handlePay}>
                  {language == "ar" ? "إنشاء الطلب" : "Make Order"}
                </button>
              ) : null}
              {payType != "wallet_and_cash" ? (
                <>
                  {" "}
                  {walletValue >
                    (discount2 != null
                      ? selectedLocations?.region_data?.price
                        ? cartDataTotalPrice -
                          (discount2?.discount.type == "percentage"
                            ? (discount2?.discount.val / 100) *
                              cartDataTotalPrice
                            : discount2?.discount.val) +
                          selectedLocations?.region_data?.price
                        : cartDataTotalPrice -
                          (discount2?.discount.type == "percentage"
                            ? (discount2?.discount.val / 100) *
                              cartDataTotalPrice
                            : discount2?.discount.val)
                      : selectedLocations?.region_data?.price
                      ? cartDataTotalPrice -
                        0 +
                        selectedLocations?.region_data?.price
                      : cartDataTotalPrice - 0) && (
                    <>
                      {addLoading ? (
                        <ThreeDots />
                      ) : (
                        <button
                          onClick={payWithWallet}
                          className="send-request-button"
                        >
                          {language == "ar"
                            ? "دفع من المحفظه"
                            : "Pay From Wallet"}
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : null}
            </div>
          )}
          {/* <PopUp
            solidOverLay={true}
            open={editLocalUserDataModal}
            title={
              language == "ar"
                ? "التسجيل لعملية الدفع"
                : "Rejesteration for payment"
            }
            setOpen={() => {
              setEditLocalUserDataModal(false);
               
            }}
            children={
              <>
                <form
                  action=''
                  onSubmit={(e) => {
                    e.preventDefault();
                    return handleCompletePayment();
                  }}
                  className='d-flex flex-column gap-3'
                >
                  <div className='my-3'>
                    <label htmlFor='phone my-2'>
                      {language == "ar" ? "اسم المستخدم" : "username"}
                      <span className='star'>*</span>
                    </label>
                    <input
                      placeholder={
                        language == "ar"
                          ? "أدخل اسم المستخدم"
                          : "Enter username"
                      }
                      type='text'
                      required
                      className='form-control py-3'
                      style={{
                        paddingBlock: "10px",
                      }}
                      name='username'
                      id='username'
                      onChange={(e) =>
                        setPaylogin({
                          ...paylogin,
                          username: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className='my-3'>
                    <label htmlFor='phone my-2'>
                      {language == "ar" ? "رقم الهاتف" : "Phone Number"}
                      <span className='star'>*</span>
                    </label>
                    <input
                      placeholder={
                        language == "ar"
                          ? "أدخل رقم الهاتف"
                          : "Enter Your Phone"
                      }
                      required
                      onWheel={(e) => e.target.blur()}
                      type='number'
                      className='form-control py-3'
                      name='phone'
                      style={{
                        paddingBlock: "10px",
                      }}
                      id='phone'
                      onChange={(e) =>
                        setPaylogin({
                          ...paylogin,
                          userphone: e.target.value,
                        })
                      }
                    />
                  </div>
                  <button className='payment-rejestration-button'>
                    متابعة
                  </button>
                </form>
              </>
            }
          /> */}
        </>
      )}
    </div>
  );
};

export default PayCard;
